import { SvgBase } from "../svg.base";

export const Clear = () => (
  <SvgBase>
    <path
      fill="currentColor"
      d="M15 24a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-9.707l-3.182-3.182-.707.707L14.293 15l-3.182 3.182.707.707L15 15.707l3.182 3.182.707-.707L15.707 15l3.182-3.182-.707-.707L15 14.293z"
    />
  </SvgBase>
);